// click-outside.js
export default {
    beforeMount(el, binding) {
      el.clickOutsideEvent = function (event) {
        // Prüfe, ob der Klick außerhalb des Elements stattfand
        if (!(el === event.target || el.contains(event.target))) {
          binding.value(event);
        }
      };
      document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted(el) {
      document.removeEventListener("click", el.clickOutsideEvent);
    },
  };
  